import AttachFileIcon from '@mui/icons-material/AttachFile'
import { Badge, Button, ButtonProps, Tooltip } from '@mui/material'
import { FC, useMemo, useState } from 'react'

import useAccessTokenAndShopId from '../../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import {
  useGetOtherPeopleProfilesQuery,
  useGetRepairOrderAttachmentEntriesQuery
} from '../../../redux/api'
import RepairOrderAttachmentDialog from './RepairOrderAttachmentDialog'

interface Props extends ButtonProps {
  repairOrderId: string
}

const RepairOrderAttachmentButton: FC<Props> = ({
  repairOrderId,
  ...props
}) => {
  const { accessToken } = useAccessTokenAndShopId()

  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const handleClose = () => setDialogOpen(false)

  const { data: attachments, isLoading: isLoadingAttachments } =
    useGetRepairOrderAttachmentEntriesQuery({
      authorization: accessToken,
      repairOrder: repairOrderId
    })

  const filteredAttachments = useMemo(() => {
    return attachments?.filter((a) => {
      return !a.info?.archivedAt
    })
  }, [attachments])

  const { data: creators, isLoading: isLoadingCreators } =
    useGetOtherPeopleProfilesQuery(
      {
        authorization: accessToken,
        user: filteredAttachments?.map((a) => a.info!.createdBy!) || []
      },
      { skip: !filteredAttachments }
    )

  return (
    <>
      {!isLoadingAttachments && !isLoadingCreators && filteredAttachments && (
        <RepairOrderAttachmentDialog
          open={dialogOpen}
          handleClose={handleClose}
          repairOrderId={repairOrderId}
          attachments={filteredAttachments!}
          creators={creators!}
        />
      )}
      <Tooltip
        title={
          isLoadingAttachments || isLoadingCreators
            ? 'Loading...'
            : 'View attachments for repair order'
        }>
        <span
          style={{
            display: 'flex'
          }}>
          <Button
            variant="text"
            color="primary"
            onClick={() => setDialogOpen(true)}
            disabled={isLoadingAttachments || isLoadingCreators}
            startIcon={
              !isLoadingAttachments &&
              !isLoadingCreators &&
              filteredAttachments ? (
                <Badge
                  badgeContent={filteredAttachments!.length}
                  color="primary">
                  <AttachFileIcon />
                </Badge>
              ) : (
                <AttachFileIcon />
              )
            }
            {...props}>
            Attachments
          </Button>
        </span>
      </Tooltip>
    </>
  )
}

export default RepairOrderAttachmentButton
